import { render, staticRenderFns } from "./SyntheticSchedule.vue?vue&type=template&id=0ed7a3dd&scoped=true"
import script from "./SyntheticSchedule.vue?vue&type=script&lang=js"
export * from "./SyntheticSchedule.vue?vue&type=script&lang=js"
import style0 from "./SyntheticSchedule.vue?vue&type=style&index=0&id=0ed7a3dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed7a3dd",
  null
  
)

export default component.exports